import styled from 'styled-components';

export const TitleContainer = styled.div`
    position: absolute;
    top: 20px;
    left: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TitleText = styled.div`
    font-size: 50px;
    color: white;
    font-weight: bold;
    text-align: center;
    font-family: 'SyneRegular';
    user-select: none;
`;

export const TitleLogo = styled.img`
    width: 100px;
    height: 100px;
    margin: 30px;
    user-select: none;
`;
